import { render, staticRenderFns } from "./FIFSCCodeField.vue?vue&type=template&id=005134f2&"
import script from "./FIFSCCodeField.vue?vue&type=script&lang=ts&"
export * from "./FIFSCCodeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports